module.exports = __webpack_public_path__ + "bitbucket.png";